import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
Vue.use(VueResource)
Vue.use(VueCookies)

// var vm
var project

// ================
Vue.http.options.root = process.env.VUE_APP_API_URL
Vue.http.interceptors.push(function (_request, _next) {
    Vue.http.headers.common['Authorization'] = 'Bearer ' + Vue.localStorage.get('api-token')
    Vue.http.headers.common['Content-Type'] = 'application/json'

    // 處理一般程序
    _next(function (_response) {
        var data = _response.body
        // console.log('執行錯誤檢查: ' + data.error_code)
        if (data) {
            switch (data.code) {
                case "1078":
                case "1079":
                    project.apis.issueToken()
                    break
                case "1080":
                    // 彈出警告視窗
                    project.common.blockAction()
                    break
                default:
                    break
            }
        }
    })
})

export default class APIs {
    constructor(_vm) {
        // vm = this
        project = _vm
    }


    // 發送 Log 到 Slack
    sendLogToSlack (_text) {
        Vue.http.post('logs', {
            text: '[' + project.run_code + '] ' + _text
        })
        console.log('[' + project.run_code + '] ' + _text)
    }

    // 獲得用戶資料
    getUserData (_userId, _success, _error) {
        Vue.http.get('user', {
            params: {
                userId: _userId
            }
        }).then(_success, _error)
    }

    // 設置用戶資料
    setUserData (_user, _success, _error) {
        Vue.http.post('user', _user).then(_success, _error)
    }

    // 更新用戶名稱
    setUserName (_userId, _userName, _success, _error) {
        Vue.http.post('member', {
            userId: _userId,
            name: _userName
        }).then(_success, _error)
    }

    // 請求用戶QRCode
    getMemberQrcode (_userId, _success, _error) {
        Vue.http.get('qrcode', {
            params: {
                userId: _userId
            }
        }).then(_success, _error)
    }

    // 請求送出簡訊
    sendSmsCodeToPhoneNumber (_data, _success, _error) {
        Vue.http.post('sms', _data).then(_success, _error)
    }

    // 請求驗證簡訊
    authSmsCodeByPhoneNumber (_data, _success, _error) {
        Vue.http.post('auth', _data).then(_success, _error)
    }

    // 請求進行預約
    reserveOrder (_data, _success, _error) {
        Vue.http.post('reserve', _data).then(_success, _error)
    }

    // 獲得預約記錄
    getReserveOrders (_userId, _success, _error) {
        Vue.http.get('reserve', {
            params: {
                userId: _userId
            }
        }).then(_success, _error)
    }

    getOrderList (_userId, _success, _error) {
        Vue.http.get('orders', {
            params: {
                userId: _userId
            }
        }).then(_success, _error)
    }
}